import { getTranslatedText } from '@nile/components';
import { Tooltip } from 'react-clone-tippy';
import { useIntl } from 'react-intl';
import React from 'react';

const TooltipWrapper = ({ title, children }) => {
  const intl = useIntl();
  const translatedTitle = getTranslatedText(intl, title || 'common.add');
  return (
    <Tooltip
      title={translatedTitle}
      delay={200}
      duration={250}
      position="bottom"
      inertia
      trigger="mouseenter"
      animation="shift"
      animateFill={false}
      dismissOnMouseOut
      arrow
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export default TooltipWrapper;
